import { PAGE_PAYMENT_CARD } from '@/constants/urls'
import { StatusGiftIcon, StatusGiftType } from './loyaltyGiftStatus'

// Product Tier
export enum TIERS_ENUM {
  CLASSIC = 'Classic',
  SILVER = 'Silver',
  GOLD = 'Gold',
  PLATINUM = 'Platinum',
  DIAMOND = 'Diamond',
  LIMITLESS = 'Limitless'
}

export enum STATUS_RULE {
  PROGRESSING = 'PROGRESSING',
  KEEPING = 'KEEPING',
  FIXED = 'FIXED',
  MAX_REACHED = 'MAX_REACHED'
}

export enum GOAL_UPGRADE_TIER {
  NIGHTS = 'NIGHTS',
  STATUS_POINTS = 'STATUS_POINTS'
}

// Card visual
export enum CARD_TIERS_ENUM {
  CLASSIC = 'Classic',
  SILVER = 'Silver',
  GOLD = 'Gold',
  PLATINUM = 'Platinum',
  DIAMOND = 'Diamond',
  LIMITLESS = 'Limitless',
  SILVER_PLUS = 'Silver plus',
  GOLD_PLUS = 'Gold plus',
  PLATINUM_PLUS = 'Platinum plus',
  APP_PLATINUM = 'APP Platinum',
  APP_DIAMOND = 'APP Diamond',
  DIAMOND_PLUS = 'Diamond plus',
  LIMITLESS_PLUS = 'Limitless plus',
  ASPAC_GOLD = 'Aspac Gold',
  ASPAC_PLATINUM = 'Aspac Platinum',
  ASPAC_DIAMOND = 'Aspac Diamond',
  PRIVATE_ONE = 'Private One'
}

export enum EXPLORER_AWARD_CATEGORY {
  WELLBEING = 'WELLBEING',
  BEVERAGE = 'BEVERAGE',
  DINE = 'DINE',
  STAY = 'STAY'
}

export enum AWARDS_ENUM {
  SNU = 'SNU',
  DIN = 'DIN',
  FDIN = 'FDIN',
  FCNI = 'FCNI',
  FRUC = 'FRUC',
  FSUC = 'FSUC',
  APEV = 'APEV'
}

export enum EXPLORER_AWARD_STATUS {
  REDEEMED = 'REDEEMED',
  REDEEMABLE = 'REDEEMABLE',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  UPCOMING = 'UPCOMING'
}

export enum AWARDS_STATUS_ENUM {
  REDEEMED = 'REDEEMED',
  REDEEMABLE = 'REDEEMABLE',
  REFUNDED = 'REFUNDED',
  CANCELLED = 'CANCELLED'
}

// In progress, TODO divide into subscription and loyalty
export enum CARD_CODE_TARS {
  CLASSIC = 'A1',
  SILVER = 'A2',
  GOLD = 'A3',
  PLATINUM = 'A4',
  DIAMOND = 'A5',
  LIMITLESS = 'A6',
  DIAMOND_PLUS = 'D1',
  LIMITLESS_PLUS = 'D2',
  SILVER_PLUS = 'D4',
  GOLD_PLUS = 'D5',
  PLATINUM_PLUS = 'D6',
  PPA_GOLD_PLUS = 'D7',
  PPA_DIAMOND_PLUS = 'D8',
  PPA_PLATINUM_PLUS = 'D9',
  RESIDENTIAL_PRIVILEGED_GOLD = 'P1',
  RESIDENTIAL_PRIVILEGED_PLATINUM = 'P2',
  RESIDENTIAL_PRIVILEGED_DIAMOND = 'P4',
  ACCOR_PRIVILEGED_PARTNER_GOLD = 'P3',
  ACCOR_PRIVILEGED_PARTNER_PLATINUM = 'P5',
  ACCOR_PRIVILEGED_PARTNER_DIAMOND = 'P7',
  PRIVATE_ONE_PRIVILEGED = 'P6',
  BUSINESS_PLUS3 = 'B3', // subscription
  BUSINESS_PLUS4 = 'B4', // subscription
  BUSINESS_PLUS5 = 'B5', // subscription
  BUSINESS_PLUS6 = 'B6', // subscription
  IBIS_GOLD = 'FI', // subscription
  ALL_ACCOR_BUSINESS = 'H8' // subscription
}

export enum CARD_CODE_TARS_ENUM {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  A5 = 'A5',
  A6 = 'A6',
  B3 = 'B3',
  B4 = 'B4',
  B5 = 'B5',
  B6 = 'B6',
  D1 = 'D1',
  D2 = 'D2',
  D4 = 'D4',
  D5 = 'D5',
  D6 = 'D6',
  D7 = 'D7',
  D8 = 'D8',
  D9 = 'D9',
  FI = 'FI',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  P5 = 'P5',
  P6 = 'P6',
  P7 = 'P7',
  G7 = 'G7',
  H8 = 'H8'
}

// Card Visual and label
// @TODO: Add G7 card type to fix typescript warning
export const LOYALTY_CARD_TYPE: Record<
  CARD_CODE_TARS_ENUM,
  { label: string; card: CARD_TIERS_ENUM }
> = {
  [CARD_CODE_TARS_ENUM.A1]: {
    label: 'Classic', // LCAH
    card: CARD_TIERS_ENUM.CLASSIC
  },
  [CARD_CODE_TARS_ENUM.A2]: {
    label: 'Silver', // LCAH
    card: CARD_TIERS_ENUM.SILVER
  },
  [CARD_CODE_TARS_ENUM.A3]: {
    label: 'Gold', // LCAH
    card: CARD_TIERS_ENUM.GOLD
  },
  [CARD_CODE_TARS_ENUM.A4]: {
    label: 'Platinum', // LCAH
    card: CARD_TIERS_ENUM.PLATINUM
  },
  [CARD_CODE_TARS_ENUM.A5]: {
    label: 'Diamond',
    card: CARD_TIERS_ENUM.DIAMOND
  },
  [CARD_CODE_TARS_ENUM.A6]: {
    label: 'Limitless',
    card: CARD_TIERS_ENUM.LIMITLESS
  },
  [CARD_CODE_TARS_ENUM.B3]: {
    label: 'Accor Favorite guest Business', // Business Plus Card
    card: CARD_TIERS_ENUM.CLASSIC // Default
  },
  [CARD_CODE_TARS_ENUM.B4]: {
    label: 'Accor Favorite guest Business', // Business Plus Card
    card: CARD_TIERS_ENUM.CLASSIC // Default
  },
  [CARD_CODE_TARS_ENUM.B5]: {
    label: 'Accor Favorite guest Business', // Business Plus Card
    card: CARD_TIERS_ENUM.CLASSIC // Default
  },
  [CARD_CODE_TARS_ENUM.B6]: {
    label: 'Accor Favorite guest Business', // Business Plus Card
    card: CARD_TIERS_ENUM.CLASSIC // Default
  },
  [CARD_CODE_TARS_ENUM.D1]: {
    label: 'Accor Plus Diamond',
    card: CARD_TIERS_ENUM.DIAMOND_PLUS
  },
  [CARD_CODE_TARS_ENUM.D2]: {
    label: 'Accor Plus Limitless',
    card: CARD_TIERS_ENUM.LIMITLESS_PLUS
  },
  [CARD_CODE_TARS_ENUM.D4]: {
    label: 'Accor Plus Silver', // Accor Plus Cards
    card: CARD_TIERS_ENUM.SILVER_PLUS
  },
  [CARD_CODE_TARS_ENUM.D5]: {
    label: 'Accor Plus Gold', // Accor Plus Cards
    card: CARD_TIERS_ENUM.GOLD_PLUS
  },
  [CARD_CODE_TARS_ENUM.D6]: {
    label: 'Accor Plus Platinum', // Accor Plus Cards
    card: CARD_TIERS_ENUM.PLATINUM_PLUS
  },
  [CARD_CODE_TARS_ENUM.D7]: {
    label: 'Aspac Owner - PPA Gold',
    card: CARD_TIERS_ENUM.ASPAC_GOLD
  },
  [CARD_CODE_TARS_ENUM.D8]: {
    label: 'Aspac Owner - PPA Diamond',
    card: CARD_TIERS_ENUM.ASPAC_DIAMOND
  },
  [CARD_CODE_TARS_ENUM.D9]: {
    label: 'Aspac Owner - PPA Platinum',
    card: CARD_TIERS_ENUM.ASPAC_PLATINUM
  },
  [CARD_CODE_TARS_ENUM.FI]: {
    label: 'ibis business',
    card: CARD_TIERS_ENUM.CLASSIC // Default
  },
  [CARD_CODE_TARS_ENUM.P1]: {
    label: 'Residential owner Gold', // Privileged
    card: CARD_TIERS_ENUM.GOLD
  },
  [CARD_CODE_TARS_ENUM.P2]: {
    label: 'Residential owner Platinum', // Privileged
    card: CARD_TIERS_ENUM.PLATINUM
  },
  [CARD_CODE_TARS_ENUM.P3]: {
    label: 'Accor Privileged Partners Gold', // Privileged
    card: CARD_TIERS_ENUM.GOLD
  },
  [CARD_CODE_TARS_ENUM.P4]: {
    label: 'Residential owner Diamond', // Privileged
    card: CARD_TIERS_ENUM.DIAMOND
  },
  [CARD_CODE_TARS_ENUM.P5]: {
    label: 'Accor Privileged Partners Platinum', // Privileged
    card: CARD_TIERS_ENUM.APP_PLATINUM
  },
  [CARD_CODE_TARS_ENUM.P6]: {
    label: 'Private one', // Privileged
    card: CARD_TIERS_ENUM.PRIVATE_ONE // Default
  },
  [CARD_CODE_TARS_ENUM.P7]: {
    label: 'Accor Privileged Partners Diamond', // Privileged
    card: CARD_TIERS_ENUM.APP_DIAMOND
  }
} as const

export type LoyaltyStateType = 'active' | 'inactive' | 'locked'
export type LoyaltyStatusIconsType =
  | 'ClassicMemberPrice'
  | 'ClassicOnlineCheckIn'
  | 'ClassicPartnerAdvantage'
  | 'DiamondBreakfastFree'
  | 'DiamondSpa'
  | 'GoldBetterRoom'
  | 'GoldLateDepartureArrival'
  | 'GoldRoomWarranty'
  | 'LimitlessAssistantPerso'
  | 'LimitlessTransferReward'
  | 'Lotus'
  | 'PlatinumExecutiveLounge'
  | 'PlatinumGift'
  | 'PlatinumSnu'
  | 'Plus'
  | 'SilverLateDeparture'
  | 'SilverPriorityWelcome'
  | 'SilverWelcomeDrink'
  | 'ExtendedStay'
  | 'WifiPremium'
  | StatusGiftIcon

export type BenefitType = {
  icon: LoyaltyStatusIconsType
  label: string
  descriptions: string | string[]
  trackingLabel: string
  statusGiftType?: StatusGiftType
}

export type ItemStatusType = {
  status: CARD_CODE_TARS_ENUM
  state: LoyaltyStateType
  isShown: boolean
}

export const LOYALTY_BASIC_CARD_CODES: CARD_CODE_TARS_ENUM[] = [
  CARD_CODE_TARS_ENUM.A1,
  CARD_CODE_TARS_ENUM.A2,
  CARD_CODE_TARS_ENUM.A3,
  CARD_CODE_TARS_ENUM.A4,
  CARD_CODE_TARS_ENUM.A5
]

export const LOYALTY_DIAMOND_CODES: CARD_CODE_TARS_ENUM[] = [
  CARD_CODE_TARS_ENUM.A5,
  CARD_CODE_TARS_ENUM.D8,
  CARD_CODE_TARS_ENUM.P4,
  CARD_CODE_TARS_ENUM.P7
]

export const LOYALTY_ALERT_PROGRESSING_CODES: CARD_CODE_TARS_ENUM[] = [
  CARD_CODE_TARS_ENUM.A1,
  CARD_CODE_TARS_ENUM.A2,
  CARD_CODE_TARS_ENUM.A3,
  CARD_CODE_TARS_ENUM.A4
]

export const LOYALTY_ALERT_KEEPING_CODES: CARD_CODE_TARS_ENUM[] = [
  CARD_CODE_TARS_ENUM.A2,
  CARD_CODE_TARS_ENUM.A3,
  CARD_CODE_TARS_ENUM.A4,
  CARD_CODE_TARS_ENUM.A5
]

export const LOYALTY_PLUS_CARD_CODES: CARD_CODE_TARS_ENUM[] = [
  CARD_CODE_TARS_ENUM.D4,
  CARD_CODE_TARS_ENUM.D5,
  CARD_CODE_TARS_ENUM.D6,
  CARD_CODE_TARS_ENUM.D1
]

// TODO: Move to composable
export const getLoyaltyStatusBenefits = (card: CARD_TIERS_ENUM) => {
  let benefits: BenefitType[]
  switch (true) {
    case card === CARD_TIERS_ENUM.SILVER || card === CARD_TIERS_ENUM.SILVER_PLUS:
      benefits = [
        {
          icon: 'SilverWelcomeDrink',
          label: 'silver.0.libelle',
          descriptions: 'silver.0.description.paragraphe',
          trackingLabel: 'Welcome drink'
        },
        {
          icon: 'SilverPriorityWelcome',
          label: 'silver.1.libelle',
          descriptions: 'silver.1.description.paragraphe',
          trackingLabel: 'Priority welcome'
        },
        {
          icon: 'SilverLateDeparture',
          label: 'silver.2.libelle',
          descriptions: 'silver.2.description.paragraphe',
          trackingLabel: 'Late check-out'
        }
      ]
      break
    case card === CARD_TIERS_ENUM.GOLD ||
      card === CARD_TIERS_ENUM.GOLD_PLUS ||
      card === CARD_TIERS_ENUM.ASPAC_GOLD:
      benefits = [
        {
          icon: 'GoldRoomWarranty',
          label: 'gold.0.libelle',
          descriptions: 'gold.0.description.paragraphe',
          trackingLabel: 'Guaranteed room availability D-3'
        },
        {
          icon: 'GoldBetterRoom',
          label: 'gold.1.libelle',
          descriptions: 'gold.1.description.paragraphe',
          trackingLabel: 'Upgrade to the next room category'
        },
        {
          icon: 'GoldLateDepartureArrival',
          label: 'gold.2.libelle',
          descriptions: 'gold.2.description.paragraphe',
          trackingLabel: 'Early arrival, late check-out'
        }
      ]
      break
    case card === CARD_TIERS_ENUM.PLATINUM ||
      card === CARD_TIERS_ENUM.PLATINUM_PLUS ||
      card === CARD_TIERS_ENUM.APP_PLATINUM ||
      card === CARD_TIERS_ENUM.ASPAC_PLATINUM ||
      card === CARD_TIERS_ENUM.PRIVATE_ONE:
      benefits = [
        {
          icon: 'PlatinumSnu',
          label: 'platinum.0.libelle',
          descriptions: 'platinum.0.description.paragraphe',
          trackingLabel: 'Guaranteed room availability D-2'
        },
        {
          icon: 'PlatinumExecutiveLounge',
          label: 'platinum.1.libelle',
          descriptions: 'platinum.1.description.paragraphe',
          trackingLabel: 'Executive Lounge'
        },
        {
          icon: 'ExtendedStay',
          label: 'platinum.2.libelle',
          descriptions: 'platinum.2.description.paragraphe',
          trackingLabel: 'Suite Night Upgrade'
        }
      ]
      break
    case card === CARD_TIERS_ENUM.DIAMOND ||
      card === CARD_TIERS_ENUM.DIAMOND_PLUS ||
      card === CARD_TIERS_ENUM.APP_DIAMOND ||
      card === CARD_TIERS_ENUM.ASPAC_DIAMOND:
      benefits = [
        {
          icon: 'DiamondSpa',
          label: 'diamond.0.libelle',
          descriptions: 'diamond.0.description.paragraphe',
          trackingLabel: 'Dining & Spa Rewards'
        },
        {
          icon: 'DiamondBreakfastFree',
          label: 'diamond.1.libelle',
          descriptions: 'diamond.1.description.paragraphe',
          trackingLabel: 'Complimentary breakfast'
        },
        {
          icon: StatusGiftIcon.Gold,
          label: 'statusgift.diamond.2.libelle',
          descriptions: 'statusgift.diamond.2.description.paragraphe',
          statusGiftType: StatusGiftType.Gold,
          trackingLabel: 'Gold Status gift'
        }
      ]
      break
    case card === CARD_TIERS_ENUM.LIMITLESS || card === CARD_TIERS_ENUM.LIMITLESS_PLUS:
      benefits = [
        {
          icon: 'LimitlessAssistantPerso',
          label: 'limitless.0.libelle',
          descriptions: 'limitless.0.description.paragraphe',
          trackingLabel: 'Personal assistant'
        },
        {
          icon: 'LimitlessTransferReward',
          label: 'limitless.1.libelle',
          descriptions: 'limitless.1.description.paragraphe',
          trackingLabel: 'Points transfer'
        },
        {
          icon: StatusGiftIcon.Platinum,
          label: 'statusgift.limitless.2.libelle',
          descriptions: 'statusgift.limitless.2.description.paragraphe',
          statusGiftType: StatusGiftType.Platinum,
          trackingLabel: 'Platinum Status gift'
        }
      ]
      break
    default:
      benefits = [
        {
          icon: 'ClassicMemberPrice',
          label: 'classic.0.libelle',
          descriptions: 'classic.0.description.paragraphe',
          trackingLabel: 'Members rate'
        },
        {
          icon: 'WifiPremium',
          label: 'classic.1.libelle',
          descriptions: 'classic.1.description.paragraphe',
          trackingLabel: 'Online check-in, fast check-out'
        },
        {
          icon: 'ClassicPartnerAdvantage',
          label: 'classic.2.libelle',
          descriptions: 'classic.2.description.paragraphe',
          trackingLabel: 'Partners benefits'
        }
      ]
      break
  }

  return benefits
}

export interface GetLoyaltyCardStatusReturn {
  code?: CARD_CODE_TARS_ENUM
  minPoints?: number
  minNights?: number
  next?: CARD_CODE_TARS_ENUM
}

export const getLoyaltyCardStatus = (code?: CARD_CODE_TARS_ENUM): GetLoyaltyCardStatusReturn => {
  const cardType = code && LOYALTY_CARD_TYPE[code].card

  switch (cardType) {
    case CARD_TIERS_ENUM.CLASSIC:
      return {
        code: CARD_CODE_TARS_ENUM.A1,
        minPoints: 0,
        minNights: 0,
        next: CARD_CODE_TARS_ENUM.A2
      }
    case CARD_TIERS_ENUM.SILVER:
      return {
        code: CARD_CODE_TARS_ENUM.A2,
        minPoints: 2000,
        minNights: 10,
        next: CARD_CODE_TARS_ENUM.A3
      }
    case CARD_TIERS_ENUM.GOLD:
      return {
        code: CARD_CODE_TARS_ENUM.A3,
        minPoints: 7000,
        minNights: 30,
        next: CARD_CODE_TARS_ENUM.A4
      }
    case CARD_TIERS_ENUM.PLATINUM:
      return {
        code: CARD_CODE_TARS_ENUM.A4,
        minPoints: 14000,
        minNights: 60,
        next: CARD_CODE_TARS_ENUM.A5
      }
    case CARD_TIERS_ENUM.DIAMOND:
      return {
        code: CARD_CODE_TARS_ENUM.A5,
        minPoints: 26000
      }
    case CARD_TIERS_ENUM.SILVER_PLUS:
      return {
        code: CARD_CODE_TARS_ENUM.D4,
        minPoints: 2000,
        minNights: 10,
        next: CARD_CODE_TARS_ENUM.D5
      }
    case CARD_TIERS_ENUM.GOLD_PLUS:
      return {
        code: CARD_CODE_TARS_ENUM.D5,
        minPoints: 7000,
        minNights: 30,
        next: CARD_CODE_TARS_ENUM.D6
      }
    case CARD_TIERS_ENUM.PLATINUM_PLUS:
      return {
        code: CARD_CODE_TARS_ENUM.D6,
        minPoints: 14000,
        minNights: 60,
        next: CARD_CODE_TARS_ENUM.D1
      }
    case CARD_TIERS_ENUM.DIAMOND_PLUS:
      return {
        code: CARD_CODE_TARS_ENUM.D1,
        minPoints: 26000
      }
    default:
      return {
        code
      }
  }
}

export enum COBRAND_PARTNER_NAME_ENUM {
  BNP = 'BNP PARIBAS',
  ADCB = 'ADCB',
  WOORI = 'WOORI CARD',
  CIMB = 'CIMB NIAGA'
}

export const VISA_CARD_TYPE = ['Explorer', 'Pulse', 'Ultimate']
export const FAST_TRACK = 'fastTrack'

export enum COBRAND_AIRLINES_PARTNER_CODE_ENUM {
  QANTAS = 'QF',
  QATAR = 'QR',
  AIR_FRANCE = 'AF',
  AZUL = 'AD',
  ACCOR_BRAZIL = 'ACCOR_BRAZIL',
  WOORI = 'WOORI',
  CIMB_NIAGA = '34'
}

type PartnerData = {
  title?: string
  description?: string
  urlLabel?: string
  url?: string
  iconName: string
  trackingLabel?: string
  unlinkUrl?: string
}

export const COBRAND_AIRLINES: Record<string, PartnerData> = {
  [COBRAND_AIRLINES_PARTNER_CODE_ENUM.AIR_FRANCE]: {
    title: 'partners.bloc.airFrance.title',
    description: 'partners.bloc.airFrance.descp',
    iconName: 'flying-blue'
  },
  [COBRAND_AIRLINES_PARTNER_CODE_ENUM.QANTAS]: {
    title: 'partners.bloc.qantas.title',
    description: 'partners.bloc.qantas.descp',
    iconName: 'qantas'
  },
  [COBRAND_AIRLINES_PARTNER_CODE_ENUM.QATAR]: {
    title: 'partners.bloc.qatar.title',
    description: 'partners.bloc.qatar.descp',
    iconName: 'qatar'
  },
  [COBRAND_AIRLINES_PARTNER_CODE_ENUM.AZUL]: {
    title: 'partners.bloc.azul.title',
    description: 'partners.bloc.azul.descp',
    iconName: 'azul',
    unlinkUrl: 'partners.unlink.azul.url'
  }
}

export const COBRAND_PARTNERS_INFOS: Record<string, PartnerData> = {
  [COBRAND_PARTNER_NAME_ENUM.ADCB]: {
    urlLabel: 'section.bonus.details',
    url: 'https://www.adcb.com/limitless',
    iconName: 'payment',
    trackingLabel: 'ADCB'
  },
  [COBRAND_PARTNER_NAME_ENUM.BNP]: {
    urlLabel: 'section.bonus.details',
    iconName: 'all-visa',
    trackingLabel: 'Visa'
  },
  WOORI: {
    urlLabel: 'section.bonus.details',
    iconName: 'all-woori',
    trackingLabel: 'Woori'
  },
  [COBRAND_PARTNER_NAME_ENUM.CIMB]: {
    urlLabel: 'section.bonus.details',
    iconName: 'all-cimb',
    trackingLabel: 'Cimb'
  }
}

export const PAYMENT_CARD_TYPE: Record<string, string> = {
  Pulse: PAGE_PAYMENT_CARD('all-visa-pulse'),
  Explorer: PAGE_PAYMENT_CARD('all-visa-explorer'),
  Ultimate: PAGE_PAYMENT_CARD('all-visa-ultimate')
}

type SubscribedBonus = {
  title: string
  iconName: string
  urlLabel?: string
  trackingLabel?: string
}

export const SUBSCRIBED_BONUSES: Record<string, SubscribedBonus> = {
  [FAST_TRACK]: {
    title: 'fasttrack.title',
    iconName: 'fast-track'
  },
  default: {
    title: 'partner.section.deals',
    iconName: 'bonuses',
    urlLabel: 'section.bonus.details',
    trackingLabel: 'Offer'
  }
}

export enum CONTEXT_TYPE_ADDRESS_ENUM {
  PERSONAL = '1',
  PRO = '2'
}

export enum CONTEXT_TYPE_ENUM {
  PERSONAL = 'Personal',
  PROFESSIONAL = 'Professional'
}

export enum USAGE_TYPE_ADDRESS_ENUM {
  COMMUNICATION = 'Communication',
  BILLING = 'Billing'
}

export enum USAGE_TYPE_EMAIL_ENUM {
  ENTERPRISE = 'Enterprise'
}

export enum USAGE_TYPE_PHONE_ENUM {
  PHONE = 'Phone',
  BILLING = 'Billing',
  FAX = 'Fax',
  GEOGRAPHICAL = 'Geographical',
  CELL = 'Cell',
  LOGIN = 'Login'
}

export enum NPAI_ENUM {
  EMAIL = 'email',
  PHONE = 'phone',
  ADDRESS = 'address'
}

export const TEMPORARY_STATUS_CARD_TIERS: Record<number, CARD_CODE_TARS_ENUM> = {
  1: CARD_CODE_TARS_ENUM.A2,
  2: CARD_CODE_TARS_ENUM.A3
}

export enum MEMBER_GIFT_STATE {
  ELIGIBLE = 'ELIGIBLE',
  NOT_ELIGIBLE = 'NOT_ELIGIBLE'
}

export enum REWARD_CARD_ENUMS {
  REWARD = 'REWARD',
  ECONOMY = 'ECONOMY',
  HOW_TO = 'HOW_TO',
  SNU = 'SNU',
  SNU_LOCKED = 'SNU_LOCKED',
  FAIRMONT = 'FAIRMONT',
  DIN = 'DIN',
  DIN_LOCKED = 'DIN_LOCKED',
  MEMBER_GIFT = 'MEMBER_GIFT'
}

export const CARD_LOCKED = 'Locked'
export const CARD_UNLOCKED = 'Unlocked'

export enum AUTH_LEVEL {
  WEAK = 'weak',
  MEDIUM = 'medium',
  STRONG = 'strong'
}

export enum PeriodType {
  NONE = 'NONE',
  PEDAGOGY = 'PEDAGOGY',
  PROGRESS = 'PROGRESS',
  SUBSCRIPTION = 'SUBSCRIPTION'
}
export enum IdentityCardType {
  PAS = 'PAS',
  IDC = 'IDC',
  CPF = 'CPF'
}

export const SUBSCRIPTION_CARD_VOYAGEUR = 'voyageur'
export const SUBSCRIPTION_CARD_EXPLORER = 'explorer'

export const STATUS_METRIC_POINTS = 'points'
export const STATUS_METRIC_NIGHTS = 'nights'

export const CARD_TYPE_NONE = 'none'
export const CARD_TYPE_WOORI = 'woori'
export const CARD_TYPE_CIMB = 'cimb'

export type CardType = typeof CARD_TYPE_WOORI | typeof CARD_TYPE_CIMB | typeof CARD_TYPE_NONE

export type SubscriptionCardType =
  | typeof SUBSCRIPTION_CARD_VOYAGEUR
  | typeof SUBSCRIPTION_CARD_EXPLORER
export type StatusMetric = typeof STATUS_METRIC_POINTS | typeof STATUS_METRIC_NIGHTS

export type AlertingStatusType = 'KEEPING' | 'PROGRESSING'

export const ALERTING_STATUS_ICON_MAPS: Record<AlertingStatusType, Record<string, string>> = {
  KEEPING: {
    [CARD_CODE_TARS_ENUM.A2]: 'alerting-statut-silver',
    [CARD_CODE_TARS_ENUM.A3]: 'alerting-statut-gold',
    [CARD_CODE_TARS_ENUM.A4]: 'alerting-statut-platinum',
    [CARD_CODE_TARS_ENUM.A5]: 'alerting-statut-diamond'
  },
  PROGRESSING: {
    [CARD_CODE_TARS_ENUM.A1]: 'alerting-statut-silver',
    [CARD_CODE_TARS_ENUM.A2]: 'alerting-statut-gold',
    [CARD_CODE_TARS_ENUM.A3]: 'alerting-statut-platinum',
    [CARD_CODE_TARS_ENUM.A4]: 'alerting-statut-diamond'
  }
} as const

export const COUNTRY_CODE_SOUTH_KOREA = 'KR'
export const COUNTRY_CODE_INDONESIA = 'ID'
export const COUNTRY_CODE_AUSTRALIA = 'AU'
export const COUNTRY_CODE_CAMBODIA = 'KH'
export const COUNTRY_CODE_CHINA = 'CN'
export const COUNTRY_CODE_FIJI = 'FJ'
export const COUNTRY_CODE_FRENCH_POLYNESIA = 'PF'
export const COUNTRY_CODE_HONG_KONG = 'HK'
export const COUNTRY_CODE_INDIA = 'IN'
export const COUNTRY_CODE_JAPAN = 'JP'
export const COUNTRY_CODE_LAOS = 'LA'
export const COUNTRY_CODE_MACAO = 'MO'
export const COUNTRY_CODE_MALAYSIA = 'MY'
export const COUNTRY_CODE_MALDIVES = 'MV'
export const COUNTRY_CODE_MONGOLIA = 'MN'
export const COUNTRY_CODE_MYANMAR = 'MM'
export const COUNTRY_CODE_NEW_ZEALAND = 'NZ'
export const COUNTRY_CODE_PHILIPPINES = 'PH'
export const COUNTRY_CODE_SINGAPORE = 'SG'
export const COUNTRY_CODE_TAIWAN = 'TW'
export const COUNTRY_CODE_THAILAND = 'TH'
export const COUNTRY_CODE_VIETNAM = 'VN'

export const ASPAC_COUNTRIES = [
  COUNTRY_CODE_AUSTRALIA,
  COUNTRY_CODE_CAMBODIA,
  COUNTRY_CODE_CHINA,
  COUNTRY_CODE_FIJI,
  COUNTRY_CODE_FRENCH_POLYNESIA,
  COUNTRY_CODE_HONG_KONG,
  COUNTRY_CODE_INDIA,
  COUNTRY_CODE_INDONESIA,
  COUNTRY_CODE_JAPAN,
  COUNTRY_CODE_LAOS,
  COUNTRY_CODE_MACAO,
  COUNTRY_CODE_MALAYSIA,
  COUNTRY_CODE_MALDIVES,
  COUNTRY_CODE_MONGOLIA,
  COUNTRY_CODE_MYANMAR,
  COUNTRY_CODE_NEW_ZEALAND,
  COUNTRY_CODE_PHILIPPINES,
  COUNTRY_CODE_SINGAPORE,
  COUNTRY_CODE_SOUTH_KOREA,
  COUNTRY_CODE_TAIWAN,
  COUNTRY_CODE_THAILAND,
  COUNTRY_CODE_VIETNAM
] as const

export enum AlertingStatusId {
  KEEPING = STATUS_RULE.KEEPING,
  PROGRESSING = STATUS_RULE.PROGRESSING,
  FIXED = STATUS_RULE.FIXED,
  MAX_REACHED = STATUS_RULE.MAX_REACHED,
  PEDAGOGY = PeriodType.PEDAGOGY,
  SUBSCRIPTION = PeriodType.SUBSCRIPTION
}
